
import { Vue, Component, Prop } from 'vue-property-decorator';
import { PackageEnum, PackageItem } from '@/features/shipment/types';
import { getPrice } from '@/features/common/helpers';

@Component
export default class PackageSummaryShipment extends Vue {
  @Prop({ required: true }) packages!: PackageItem[];

  private getPrice: (val: number, roundTo: number) => string = getPrice;

  private getPackageName = (name: string): PackageEnum => PackageEnum[name];

  private getWeight = (item: PackageItem): string => `${item.weight.toFixed(1)} ${item.weightUnits}`;

  private getDimensions = (item: PackageItem): string => {
    if (item.length && item.width && item.height) {
      return `${item.length} x ${item.width} x ${item.height} ${item.dimUnits}`;
    }

    let label = this.$t('shipment.whatShipment.packagesSummary.labels.notProvided');
    if (item.packageType === 'Envelope' || item.packageType === 'Pak') {
      label = this.$t('global.na');
    }

    return `<span class="text-gray">${label}</span>`;
  };

  private getIsAdditionalHandling(item: PackageItem): string {
    return this.$t(`tables.${item.isAdditionalHandling ? 'yes' : 'no'}`) as string;
  }
}
